import { planTypes } from '@/common/constants';
import { getPlanLogo } from '@/common/plan-logo-map';

export default {
  key: planTypes[planTypes.ZCM],
  data() {
    return {
      logo: getPlanLogo(planTypes.ZCM),
      title: this.$t('billing.zcm.title'),
      planType: planTypes.ZCM,
      configDescription: this.$t('billing.zcm.description'),
      description: this.$t('billing.zcm.addon_description'),
    };
  },
};
